<div class="skl-ai-chat-settings" aria-busy="true" aria-label="Loading AI chat settings">
  <app-skeleton width="230px" height="18px" borderRadius="4px" marginBottom="16px" class="d-block"></app-skeleton>

  <div class="skl-copy">
    <app-skeleton width="380px" height="13px" borderRadius="3px" marginBottom="8px"></app-skeleton>
    <app-skeleton width="320px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
  </div>

  <div class="skl-card skl-card--summary">
    <div class="skl-card__body">
      <app-skeleton width="190px" height="18px" borderRadius="4px" marginBottom="20px"></app-skeleton>

      @for (row of summaryRows; track row) {
        <div class="skl-summary-row">
          <app-skeleton width="180px" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
          <app-skeleton [width]="row === 1 ? '40%' : row === 2 ? '28%' : row === 3 ? '24%' : row === 4 ? '22%' : row === 5 ? '18%' : '80px'" height="13px" borderRadius="3px" marginBottom="0"></app-skeleton>
        </div>
      }

      <div class="skl-actions-row">
        <app-skeleton width="132px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
      </div>
    </div>
  </div>

  <div class="skl-card">
    <div class="skl-card__body">
      <app-skeleton width="220px" height="18px" borderRadius="4px" marginBottom="20px"></app-skeleton>

      @for (row of formRows; track row) {
        <div class="skl-form-group">
          <app-skeleton width="170px" height="13px" borderRadius="3px" marginBottom="10px"></app-skeleton>
          <app-skeleton width="100%" [height]="row === 4 ? '112px' : '40px'" borderRadius="4px" marginBottom="0" class="d-block"></app-skeleton>
        </div>
      }

      <div class="skl-actions-row skl-actions-row--between">
        <app-skeleton width="132px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
        <app-skeleton width="104px" height="38px" borderRadius="4px" marginBottom="0"></app-skeleton>
      </div>
    </div>
  </div>
</div>